var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-absolute container-fluid after border-top py-2 profile-menu w-menu bg-white rounded-bottom poppins-regular",style:(_vm.navHeight)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }